<template>
	<v-dialog
		v-model="displayDialog"
		persistent
		width="400"
	>
		<v-card>
			<v-card-title class="subtitle-1 text-center">
				<v-icon color=warning>error</v-icon>
				<v-divider>
					<v-spacer/>
				</v-divider>
				Advertencia
				<v-divider>
					<v-spacer/>
				</v-divider>
				<v-icon color=warning>error</v-icon>
			</v-card-title>

			<v-card-text 
				v-html="msg"
				class="text-center"
			/>
			<v-card-text
				v-if="outdated"
				v-html="fechaEol"
				class="text-center"
			/>
			<v-card-text
				v-else-if="$store.getters['version/codMsgAction']=='COD_NO_RELEASE'"
				v-html="fechaRelease"
				class="text-center"
			/>
			<v-card-text
				v-else-if="!$store.getters['version/valid']"
				class="text-center"
			/>
			
			<v-card-actions>
				<v-btn
					:color="!outdated? 'warning': 'primary'"
					text block
					@click="onAceptar"
					v-text="!outdated? 'Aceptar': 'Entendido'"
				/>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>

export default {
	computed: {
		displayDialog: {
			get(){
				let display = this.display;
				let valid = this.$store.getters['version/valid'];

				let outdated = this.outdated;
				
				if( valid===undefined ){
					this.display = undefined;
					return false
				}else if(display === false){
					return display;
				}else{
					return outdated || !valid;
				}
			},
			set(val){
				this.display = val;
			}
		},
		msg(){
			// window.Android
			let msg = this.$store.getters['version/msg'];
			let codMsg = this.$store.getters['version/codMsgAction'];
			let msgFromCod = !codMsg?undefined: this.$t(`controlVersion.estados.${codMsg}`);
			let msgFallBack = !this.$store.getters['version/valid']?
				this.$t('controlVersion.estados.COD_EOL'):
				this.$t('controlVersion.estados.dafault');

			return msg || msgFromCod || msgFallBack;
		},
		outdated(){
			return this.$store.getters['version/outdated'];
		},
		fechaRelease(){
			let fecha = this.$store.getters['version/fechaAccion'];
			if( !fecha )	return '';
			fecha = new Date(fecha);
			let yyyy = fecha.getFullYear();
			let mes = fecha.getMonth()+1;
			let dd = fecha.getDate();

			let formatFecha = function(n){return n<10?'0'+n:n;}

			let hh = formatFecha(fecha.getHours());
			let mm = formatFecha(fecha.getMinutes());
			let ss = formatFecha(fecha.getSeconds());

			let msg= `<strong>${dd}/${mes}/${yyyy}</strong> a las <strong>${hh}:${mm}:${ss}</strong>`;
			return `Esta versión será liberada el día <br/>`+msg;
		},
		fechaEol(){
			let currentAccion = this.$store.getters['version/currentAccion'] || {};
			let {eol:{fecha}={}} = currentAccion;
			if( !fecha )	return '';
			fecha = new Date(fecha);
			let yyyy = fecha.getFullYear();
			let mes = fecha.getMonth()+1;
			let dd = fecha.getDate();

			let formatFecha = function(n){return n<10?'0'+n:n;}

			let hh = formatFecha(fecha.getHours());
			let mm = formatFecha(fecha.getMinutes());
			let ss = formatFecha(fecha.getSeconds());

			let msg= `<strong>${dd}/${mes}/${yyyy}</strong> a las <strong>${hh}:${mm}:${ss}</strong>`;
			return `Esta versión ya no podrá ser utilizada desde el día <br/>`+msg;
		}
	},
	data() {
		return {
			display: undefined,
		}
	},
	methods:{	
		checkVersion(){

		},
		onAceptar(){
			this.display = false;
			
			if(!this.outdated){
				this.onAceptarEol();
			}else{
				this.onAceptarOutdated();
			}
		},
		onAceptarEol(){
			let pathName = this.$route.name;
			
			if( pathName != 'inicio-sesion' ){
				this.$router.push({name: 'inicio-sesion'});
			}
		},
		async onAceptarOutdated(){
			
			this.$store.dispatch('version/resetEstados');
			this.$emit('entendido');
		}
	}
}
</script>

<style>

</style>